import * as React from "react";
import type { SVGProps } from "react";
const SvgBolt = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="300 -860 360 760" width="24px" fill="#e83e8c" {...props}><path d="m456-200 174-340H510v-220L330-420h126v220Z" /></svg>;
export default SvgBolt;